import { rbwInit, rbwOnMessage, rbwOnNewAttendee, rbwStream,
  rbwCallStart, rbwCtrl, rbwMute, rbwUnmute, rbwMuteAll, rbwUnmuteAll, 
  rbwUiShareScreen, rbwAllAudioOutputDevices, rbwCurrentAudioOutputDevice,
  rbwSetAudioOutputDevice, rbwAllVideoInputDevices, rbwCurrentVideoInputDevice,
  rbwSetVideoInputDevice, rbwAllAudioInputDevices, rbwCurrentAudioInputDevice,
  rbwSetAudioInputDevice, rbwAttachVideo, rbwDelegate } from './meet_rbw.js'

export default {
  init: async (token, cbk) => { return await rbwInit(token, cbk) },
  onMessage: (event, tab) => { return rbwOnMessage(event, tab) },
  onNewAttendee: (att) => { return rbwOnNewAttendee(att) },
  callStart: () => { return rbwCallStart() },
  ctrl: () => { return rbwCtrl() },
  mute: (attendee) => { return rbwMute(attendee) },
  unmute: (attendee) => { return rbwUnmute(attendee) },
  muteAll: () => { return rbwMuteAll() },
  unmuteAll: () => { return rbwUnmuteAll() },
  stream: (mode, param) => { return rbwStream(mode, param) },
  videoQuality: (mode) => { return false },
  uiShareScreen: (mode, sharer) => { return rbwUiShareScreen(mode, sharer) },
  getAllVideoInputDevices : () => { return rbwAllVideoInputDevices() },
  getCurrentVideoInputDevice : () => { return rbwCurrentVideoInputDevice() },
  setVideoInputDevice : (device) => { return rbwSetVideoInputDevice(device) },
  getAllAudioInputDevices : () => { return rbwAllAudioInputDevices() },
  getCurrentAudioInputDevice : () => { return rbwCurrentAudioInputDevice() },
  setAudioInputDevice : (device) => { return rbwSetAudioInputDevice(device) },
  getAllAudioOutputDevices : () => { return rbwAllAudioOutputDevices() },
  getCurrentAudioOutputDevice : () => { return rbwCurrentAudioOutputDevice() },
  setAudioOutputDevice : (device) => { return rbwSetAudioOutputDevice(device) },
  attachVideo : (id, videoSession) => {return rbwAttachVideo(id,videoSession)},
  delegate: (attendee) => {return rbwDelegate(attendee)}
}
